<template>
  <v-menu
    :id="id"
    v-model="menu"
    location="bottom left"
    content-class="ag-filter__menu"
    width="384px"
    :target="target"
    :activator="activator"
    :close-on-content-click="false"
  >
    <AGCard class="ag-filter__menu-content" has-rounded-top>
      <div class="ag-filter__menu-head">
        <p class="ag-filter__menu-title">Filtro</p>

        <AGButtonIcon icon="md:close" size="md" @click="emitClickClose()" />
      </div>

      <div class="ag-filter__menu-body">
        <slot name="prepend" />

        <div class="ag-filter__menu-fields">
          <slot />
        </div>

        <div class="ag-filter__menu-actions">
          <AGButton :disabled="disableApply" @click="emitClickApply"> Aplicar filtro </AGButton>

          <AGButton
            icon-size="22px"
            left-icon="mdi-delete-outline"
            type="secondary"
            :disabled="disableClear"
            @click="emitClickClear"
          >
            Limpar filtro
          </AGButton>
        </div>
      </div>
    </AGCard>
  </v-menu>
</template>

<script>
import AGButton from '@/components/common/AGButton.vue';
import AGButtonIcon from '@/components/common/AGButtonIcon.vue';
import AGCard from '@/components/common/AGCard.vue';

export default {
  emits: ['open', 'click:close', 'click:apply', 'click:clear', 'update:modelValue'],
  components: {
    AGButton,
    AGButtonIcon,
    AGCard,
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },

    disableApply: {
      type: Boolean,
      default: false,
    },

    disableClear: {
      type: Boolean,
      default: false,
    },

    activator: {
      type: String,
      default: undefined,
    },

    target: {
      type: [String, Boolean],
      default: undefined,
    },

    id: {
      type: String,
      default: 'ag-filter',
    },
  },

  computed: {
    menu: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },

  watch: {
    modelValue(newVal) {
      if (newVal) this.emitOpen();
    },
  },

  methods: {
    closeFilterMenu() {
      this.menu = false;
    },

    emitOpen() {
      this.$emit('open');
    },

    emitClickClose() {
      this.$emit('click:close');
      this.closeFilterMenu();
    },

    emitClickApply() {
      this.$emit('click:apply');
      this.closeFilterMenu();
    },

    emitClickClear() {
      this.$emit('click:clear');
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep(.ag-filter__menu) {
  border: none !important;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);

  .ag-filter__menu-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 0;

    .ag-filter__menu-head,
    .ag-filter__menu-actions,
    .ag-filter__menu-fields {
      padding: 16px;
    }

    .ag-filter__menu-head {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      border-bottom: solid 1px #dedede;

      .ag-filter__menu-title {
        margin: 0;
        color: $neutral-color-high-dark;
        font-size: $font-size-sm;
        font-weight: $font-weight-bold;
      }
    }

    .ag-filter__menu-body {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      gap: 32px;

      .ag-filter__menu-title {
        margin: 0;
        color: $neutral-color-high-dark;
        font-size: $font-size-sm;
        font-weight: $font-weight-bold;
      }
    }

    .ag-filter__menu-fields {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      gap: 16px;
      padding-bottom: 0;
      max-height: 50vh;
      overflow-y: auto;
      @media (min-height: 800px) {
        max-height: 550px;
      }
    }

    .ag-filter__menu-actions {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: space-between;
      padding-top: 0;
      gap: 16px;
    }
  }
}
</style>
